import { useNavigate } from 'react-router-dom'
import { useProjectStore } from '@/store/projectStore'
import { useProjectPermissions } from '@/auth/useProjectPermissions'
import { useJourneyAction } from '@/lib/journeyActions'
import { ADVANCED_GROUPS, openAdvancedItem } from './advanced'

/**
 * Advanced — every tool that exists today, in named groups (plan §10). The
 * groups are data (advancedGroups.json); each item opens the SAME page or
 * component it opened before.
 */
export default function AdvancedHome() {
  const navigate = useNavigate()
  const project = useProjectStore((s) => s.currentProject?.application.folder_name || '')
  const perms = useProjectPermissions()
  const run = useJourneyAction()
  return (
    <div className="swb swb-page">
      <div className="swb-head">
        <div>
          <h1>Advanced</h1>
          <p>Tools for developers and administrators. You don’t need any of these to build your app and put it live.</p>
        </div>
      </div>
      {ADVANCED_GROUPS.map((g) => {
        const items = g.items.filter((it) => !it.permission || !perms.loaded || perms.isOwner || perms.has(it.permission as Parameters<typeof perms.has>[0]))
        if (!items.length) return null
        return (
          <section key={g.id} aria-labelledby={`adv-${g.id}`} style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            <h2 id={`adv-${g.id}`} style={{ margin: 0, fontSize: '0.9375rem', fontWeight: 600 }}>{g.title}</h2>
            <div className="swb-grid">
              {items.map((it) => (
                <button key={it.id} type="button" className="swb-tile" data-tw-advanced={it.id}
                  onClick={() => openAdvancedItem(it, project, navigate, run)}>
                  <strong>
                    <span className="material-icons" aria-hidden="true" style={{ fontSize: 19, color: 'var(--color-accent)' }}>{it.icon}</span>
                    {it.title}
                  </strong>
                  <span className="swb-muted">{it.line}</span>
                </button>
              ))}
            </div>
          </section>
        )
      })}
    </div>
  )
}
